import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { StudioTransactionTable } from '~features/payment/ui/studio-transaction-table';

export const StudioTransactionTablePage = () => {
  return (
    <div>
      <Link to='/dashboard' className='flex w-max items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>Studio Transaction Table</h2>
      </Link>
      <div className='mb-6 mt-8 border-t' />
      <StudioTransactionTable />
    </div>
  );
};
